/* eslint-disable jsx-a11y/alt-text */
import styles from './style.module.scss';
import banner from "./IMAGE-HeaderBanner.png";
export default function BannerHeader(props) {
    return <div className={`${styles.banner} ${props.className}`}>
        <img src={banner} />
        <div>{props.children}</div>
    </div>
}